import React from "react";
import './AreaRiservata.css'
import { Container, Row, Col } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving";
import imageUrl1 from "../../Assets/miocond.png";
import imageUrl2 from "../../Assets/os-android-w.png";
import imageUrl3 from "../../Assets/os-apple-w.png";

function AreaRiservata() {
  return (
    <section>
      <Container fluid className="home-section" id="areariservata">
        <Container className="AreaRiservata-content"> 
            <Row md={7} className="AreaRiservata-header">
              <h1 style={{ paddingTop: 40 }}>
              AREA RISERVATA
              </h1>
            </Row>
            <div className="AreaRiservata-rainbow">
              <Row>
                <Col md={8} >
                <br></br>      
                Tramite questo servizio i Condomini possono collegarsi al portale MioCondominio, da fisso o da mobile, dopo aver ricevuto una password dall’Amministratore , e consultare tutti i dati personali ed i documenti del Condominio.
                </Col>
                <Col md={4} >
                  <a href="https://www.miocondominio.eu/"  target="_blank">
                      <div className= "AreaRiservata-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                            <img src={imageUrl1} alt= ''/>
                      </div>
                  </a>
                </Col>
                <Row>
                  <Col md={3} >
                    <div className= "AreaRiservata-image-icon"  style={{ paddingTop: 10, paddingBottom :10 }}>
                      <a href="https://play.google.com/store/apps/details?id=it.daneasoft.miocondominio" target="_blank">
                                <img src={imageUrl2} alt= '' align="center"/>
                      </a>
                    </div>
                  </Col>
                  <Col md={3} >
                    <div className= "AreaRiservata-image-icon"  style={{ paddingTop: 10, paddingBottom :10 }}>
                      <a href="https://apps.apple.com/it/app/miocondominio/id1053912895?uo=4&mt=8" target="_blank">
                                <img src={imageUrl3} alt= '' align="center"/>
                      </a>
                    </div>
                  </Col>
                  
                </Row>  
              </Row>
              
            </div>
            

        </Container>  
      </Container>
    </section>
  );
}

export default AreaRiservata;
